"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegendData = exports.getChartMax = exports.getScaleFromGrid = exports.generateGrid = exports.getSize = exports.getBarTotal = void 0;
/**
 * Total the value of the segments in a bar.
 */
var getBarTotal = function (_a) {
    var segments = _a.segments;
    return segments.reduce(function (s, _a) {
        var value = _a.value;
        return s + value;
    }, 0);
};
exports.getBarTotal = getBarTotal;
/**
 * Calculate what percentage numberA is of numberB.
 */
var getSize = function (numA, numB) {
    return "".concat((100 * numA) / numB, "%");
};
exports.getSize = getSize;
/**
 * Generate a grid using the scale provided that has enough lines to support the max value.
 */
var generateGridFromScale = function (max, scale) {
    // Ensure grid is slightly larger than the max so bars don't reach the top.
    var padded = scale < 1 ? max + 0.1 : max + 1;
    return Array.from(Array(Math.ceil(padded / scale)), function (_, i) {
        return Number(((i + 1) * scale).toFixed(2));
    });
};
/**
 * Create a grid based on the maximum number it needs to display.
 */
var generateGrid = function (max) {
    switch (true) {
        case max < 0.5:
            return generateGridFromScale(max, 0.1);
        case max < 1:
            return generateGridFromScale(max, 0.2);
        case max < 2:
            return generateGridFromScale(max, 0.4);
        case max < 5:
            return generateGridFromScale(max, 0.5);
        case max < 10:
            return generateGridFromScale(max, 1);
        case max < 20:
            return generateGridFromScale(max, 2);
        case max < 50:
            return generateGridFromScale(max, 5);
        case max < 100:
            return generateGridFromScale(max, 10);
        case max < 200:
            return generateGridFromScale(max, 20);
        case max < 500:
            return generateGridFromScale(max, 50);
        case max < 1000:
            return generateGridFromScale(max, 100);
        case max < 2000:
            return generateGridFromScale(max, 200);
        case max < 5000:
            return generateGridFromScale(max, 500);
        case max < 10000:
            return generateGridFromScale(max, 1000);
        default:
            return generateGridFromScale(max, 10000);
    }
};
exports.generateGrid = generateGrid;
/**
 * Get the largest number in the grid - the size of everything is based on this.
 */
var getScaleFromGrid = function (grid) { return grid[grid.length - 1]; };
exports.getScaleFromGrid = getScaleFromGrid;
/**
 * Go through the chart data and calculate the highest value the chart needs to support.
 */
var getChartMax = function (chartData) {
    return chartData.reduce(function (acc, _a) {
        var bars = _a.bars, lines = _a.lines;
        var topBarValue = bars.reduce(function (b, bar) {
            var barValue = (0, exports.getBarTotal)(bar);
            return barValue > b ? barValue : b;
        }, 0);
        var topLineValue = lines
            ? lines.reduce(function (l, line) {
                return line.value > l ? line.value : l;
            }, 0)
            : 0;
        var topValue = topLineValue > topBarValue ? topLineValue : topBarValue;
        return topValue > acc ? topValue : acc;
    }, 0);
};
exports.getChartMax = getChartMax;
/**
 * Return the Legend data for a type.
 */
var getLegendData = function (legend, type) {
    var result = legend && type && legend.find(function (item) { return item.type === type; });
    return (result || {
        type: '',
        label: '',
        color: '',
    });
};
exports.getLegendData = getLegendData;
